module.exports = __webpack_public_path__ + "static/media/favicon-196x196.a523b482.png";